import React from 'react';
import './Loading.css';

const Loading = ({ overlay = false, size = 'md', className = '' }) => {
  const spinner = (
    <div className={`pos-loading-spinner${size === 'sm' ? ' pos-loading-spinner--sm' : ''}`} />
  );

  if (overlay) {
    return (
      <div id="preloader" className={className}>
        {spinner}
      </div>
    );
  }

  return (
    <div className={`ld-inline${className ? ' ' + className : ''}`}>
      {spinner}
    </div>
  );
};

export default Loading;
